<template>
  <base-dialog
    v-model="show"
    @close="close"
    :loading="loading"
    max-width="450px"
    min-width="350px"
    width="50%"
  >
    <template v-slot:title> Cài đặt </template>
    <template #content>
      <v-card-text class="pa-0">
        <div class="d-flex flex-column full-height">
          <v-tabs v-model="tab" class="flex-grow-0" grow>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="flex-grow-1 overflow-auto">
            <v-tab-item>
              <v-card-text>
                <v-form>
                  <!-- WMS settings form -->
                  <v-switch
                    v-model="wmsSettings.enabled"
                    inset
                    label="Bật WMS"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-switch
                    v-model="wmsSettings.watermark.enabled"
                    inset
                    label="Bật chữ ký ảnh"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-file-input
                    v-model="wmFile"
                    show-size
                    counter
                    label="URL chữ ký ảnh"
                    :disabled="!wmsSettings.watermark.enabled"
                    @change="preview_image"
                    filled
                  ></v-file-input>
                  <v-img
                    :src="wmImageSrc"
                    max-height="100"
                    max-width="100"
                    class="my-2"
                  ></v-img>
                  <v-select
                    v-model="wmsSettings.watermark.position"
                    :items="positions"
                    label="Vị trí chữ ký ảnh"
                    :disabled="!wmsSettings.watermark.enabled"
                    item-text="name"
                    item-value="value"
                    filled
                  ></v-select>
                  <v-slider
                    v-model="wmsSettings.watermark.transparency"
                    :min="0"
                    :max="100"
                    :disabled="!wmsSettings.watermark.enabled"
                  ></v-slider>
                  <v-text-field
                    v-model="wmsSettings.watermark.transparency"
                    type="number"
                    label="Mức độ trong suốt của chữ ký ảnh"
                    :disabled="!wmsSettings.watermark.enabled"
                    filled
                    readonly
                  ></v-text-field>
                  <v-switch
                    v-model="wmsSettings.getFeatureInfoMimeTypeCheckingEnabled"
                    inset
                    label="Bật kiểm tra kiểu MIME cho yêu cầu GetFeatureInfo"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-switch
                    v-model="wmsSettings.getMapMimeTypeCheckingEnabled"
                    inset
                    label="Bật kiểm tra kiểu MIME cho một yêu cầu GetMapInfo"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-text-field
                    v-model="wmsSettings.maxBuffer"
                    type="number"
                    label="Số bộ đệm bản đồ tối đa"
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="wmsSettings.maxRenderingErrors"
                    type="number"
                    label="Số lỗi kết xuất tối đa"
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="wmsSettings.maxRenderingTime"
                    type="number"
                    label="Thời gian kết xuất tối đa"
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="wmsSettings.maxRequestMemory"
                    type="number"
                    label="Bộ nhớ yêu cầu tối đa"
                    filled
                  ></v-text-field>
                  <!-- WMS settings form -->
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-form>
                  <!-- WFS settings form -->
                  <v-switch
                    v-model="wfsSettings.enabled"
                    inset
                    label="Bật WFS"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-switch
                    v-model="wfsSettings.allowGlobalQueries"
                    inset
                    label="Truy vấn toàn cục"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-switch
                    v-model="wfsSettings.featureBounding"
                    inset
                    label="Trả về vùng bao của dữ liệu"
                    class="mx-1"
                  >
                  </v-switch>
                  <!-- <v-switch
                    v-model="wfsSettings.hitsIgnoreMaxFeatures"
                    inset
                    label="Bỏ qua số lượng tính năng tối đa khi tính số lần truy cập"
                    class="mx-1"
                  >
                  </v-switch> -->
                  <v-switch
                    v-model="wfsSettings.includeWFSRequestDumpFile"
                    inset
                    label="Bao gồm tệp kết xuất yêu cầu WFS"
                    class="mx-1"
                  >
                  </v-switch>
                  <v-text-field
                    v-model="wfsSettings.maxFeatures"
                    type="number"
                    label="Số đặc trưng tối đa"
                    filled
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-form>
                  <v-switch
                    v-model="gwcSettings.config.cacheLayersByDefault"
                    inset
                    label="Mặc định cache lớp bản đồ"
                  ></v-switch>
                  <!-- <v-switch
                    v-model="gwcSettings.config.cacheNonDefaultStyles"
                    inset
                    label="Cache các style không phải mặc định"
                  ></v-switch> -->
                  <v-expansion-panels inset class="my-1">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >Các lớp bản đồ đã cache</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-list>
                          <v-list-item
                            v-for="(layer, id) in gwcSettings.layers"
                            :key="id"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ layer }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels inset class="my-1">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >Gridset được cache mặc định</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-list>
                          <v-list-item
                            v-for="(gridset, id) in gwcSettings.config
                              .defaultCachingGridSetIds.string"
                            :key="id"
                          >
                            <v-list-item-content>
                              <v-card flat>
                                {{ gridset }}
                                <v-icon
                                  color="error"
                                  @click="deleteGridset(id)"
                                  right
                                  >mdi-close</v-icon
                                >
                              </v-card>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-select
                          v-model="gwcSettings.gridset"
                          :items="
                            gwcSettings.gridsets.filter(
                              (x) =>
                                !gwcSettings.config.defaultCachingGridSetIds.string.includes(
                                  x
                                )
                            )
                          "
                          label="Thêm gridset"
                          filled
                        ></v-select>
                        <v-icon color="green" @click="addGridset()"
                          >mdi-check</v-icon
                        >
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <v-expansion-panels inset class="my-1">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >Định dạng cache vector mặc
                        định</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-list>
                          <v-list-item
                            v-for="(vFormat, id) in gwcSettings.config
                              .defaultVectorCacheFormats.string"
                            :key="id"
                          >
                            <v-list-item-content>
                              <v-card flat>
                                {{ vFormat }}
                                <v-icon
                                  color="error"
                                  @click="deleteVFormat(id)"
                                  right
                                  >mdi-close</v-icon
                                >
                              </v-card>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-select
                          v-model="gwcSettings.vformat"
                          :items="
                            gwcSettings.formats.filter(
                              (x) =>
                                !gwcSettings.config.defaultVectorCacheFormats.string.includes(
                                  x
                                )
                            )
                          "
                          label="Thêm định dạng"
                          filled
                        ></v-select>
                        <v-icon color="green" @click="addVFormat()"
                          >mdi-check</v-icon
                        >
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <v-expansion-panels inset class="my-1">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >Định dạng cache loại khác mặc
                        định</v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-list>
                          <v-list-item
                            v-for="(oFormat, id) in gwcSettings.config
                              .defaultOtherCacheFormats.string"
                            :key="id"
                          >
                            <v-list-item-content>
                              <v-card flat>
                                {{ oFormat }}
                                <v-icon
                                  color="error"
                                  @click="deleteOFormat(id)"
                                  right
                                  >mdi-close</v-icon
                                >
                              </v-card>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-select
                          v-model="gwcSettings.oformat"
                          :items="
                            gwcSettings.formats.filter(
                              (x) =>
                                !gwcSettings.config.defaultOtherCacheFormats.string.includes(
                                  x
                                )
                            )
                          "
                          label="Thêm định dạng"
                          filled
                        ></v-select>
                        <v-icon color="green" @click="addOFormat()"
                          >mdi-check</v-icon
                        >
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-form>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card-text>
    </template>
    <template #extra-btn>
      <v-btn
        outlined
        color="primary"
        rounded
        @click="setSettings()"
        :disabled="loading"
      >
        <v-icon color="primary" small>mdi-pencil</v-icon>
        Cập nhật
      </v-btn>
    </template>
  </base-dialog>
</template>

<script>
import axios from '@service/auth-sdk'
export default {
  props: {},
  data: () => ({
    tab: null,
    show: false,
    loading: false,
    items: ['WMS', 'WFS', 'GWC'],
    //wms settings
    wmsSettings: {
      bboxForEachCRS: false,
      citeCompliant: false,
      dynamicStylingDisabled: false,
      getFeatureInfoMimeTypeCheckingEnabled: false,
      getMapMimeTypeCheckingEnabled: false,
      interpolation: '',
      maxBuffer: 0,
      maxRenderingErrors: 0,
      maxRenderingTime: 0,
      maxRequestMemory: 0,
      maxRequestedDimensionValues: 0,
      onlineResource: '',
      schemaBaseURL: '',
      watermark: {
        enabled: false,
        position: '',
        transparency: 0,
      },
      abstrct: '',
      accessConstraints: '',
      enabled: false,
      fees: '',
      internationalAbstract: '',
      internationalTitle: '',
      maintainer: '',
      name: '',
      title: '',
      versions: '',
    },
    wmFile: null,
    positions: [
      {
        name: 'Phía trên bên trái',
        value: 'TOP_LEFT',
      },
      {
        name: 'Phía trên chính giữa',
        value: 'TOP_CENTER',
      },
      {
        name: 'Phía trên bên phải',
        value: 'TOP_RIGHT',
      },
      {
        name: 'Chính giữa bên trái',
        value: 'MID_LEFT',
      },
      {
        name: 'Trung tâm',
        value: 'MID_CENTER',
      },
      {
        name: 'Chính giữa bên phải',
        value: 'MID_RIGHT',
      },
      {
        name: 'Phía dưới bên trái',
        value: 'BOT_LEFT',
      },
      {
        name: 'Phía dưới chính giữa',
        value: 'BOT_CENTER',
      },
      {
        name: 'Phía dưới bên phải',
        value: 'BOT_RIGHT',
      },
    ],
    //wfs settings:
    wfsSettings: {
      accessConstraints: '',
      allowGlobalQueries: false,
      canonicalSchemaLocation: false,
      citeCompliant: false,
      enabled: false,
      encodeFeatureMember: false,
      featureBounding: false,
      fees: 'NONE',
      gml: {
        entry: [
          {
            version: 'V_10',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
          {
            version: 'V_20',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
          {
            version: 'V_11',
            gml: {
              srsNameStyle: '',
              overrideGMLAttributes: false,
            },
          },
        ],
      },
      hitsIgnoreMaxFeatures: false,
      includeWFSRequestDumpFile: false,
      maxFeatures: 1000000,
      metadataLink: '',
      onlineResource: '',
      schemaBaseURL: '',
      serviceLevel: '',
      simpleConversionEnabled: false,
      verbose: false,
    },
    nstyles: [
      'EPSG Code',
      'OGC HTTP URL',
      'OGC EXPERIMENTAL URN',
      'OGC URN',
      'OGC HTTP URI',
    ],
    levels: ['Cơ bản', 'Giao dịch', 'Hoàn thiện'],
    gwcSettings: {
      layers: [],
      gridsets: [],
      gridset: '',
      formats: [
        'application/json;type=utfgrid',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/png8',
        'image/vnd.jpeg-png',
        'image/vnd.jpeg-png8',
      ],
      cformat: '',
      vformat: '',
      oformat: '',
      config: {
        directWMSIntegrationEnabled: false,
        requireTiledParameter: false,
        WMSCEnabled: false,
        TMSEnabled: false,
        securityEnabled: false,
        innerCachingEnabled: false,
        persistenceEnabled: false,
        cacheProviderClass: '',
        cacheConfigurations: {
          entry: {
            string: '',
            InnerCacheConfiguration: {
              hardMemoryLimit: 0,
              policy: '',
              concurrencyLevel: 0,
              evictionTime: 0,
            },
          },
        },
        cacheLayersByDefault: false,
        cacheNonDefaultStyles: false,
        metaTilingX: 0,
        metaTilingY: 0,
        gutter: 0,
        defaultCachingGridSetIds: {
          string: [],
        },
        defaultVectorCacheFormats: {
          string: [],
        },
        defaultOtherCacheFormats: {
          string: [],
        },
      },
    },
    wmImageSrc: '',
  }),
  computed: {},
  methods: {
    open() {
      this.show = true
      this.loading = true
      this.wmImageSrc = '/api/workspace/watermark'
      Promise.all([
        this.getCurrentWMS(),
        this.getCurrentWFS(),
        this.getCurrentGWC(),
      ]).finally(() => {
        this.loading = false
      })
    },
    close() {
      this.show = false
      this.loading = false
    },
    preview_image() {
      if (this.wmFile) {
        this.wmImageSrc = URL.createObjectURL(this.wmFile)
      } else {
        this.wmImageSrc = '/api/workspace/watermark'
      }
    },
    //WMS settings
    getCurrentWMS() {
      axios.get('workspaces/wms_settings').then((response) => {
        for (const setting in response.data.wms) {
          this.$set(this.wmsSettings, setting, response.data.wms[setting])
        }
      })
    },
    setWMSSettings() {
      axios.put('workspaces/wms_settings', {
        wms: this.wmsSettings,
      })
      if (this.wmsSettings.enabled) {
        let formData = new FormData()
        formData.append('position', this.wmsSettings.watermark.position)
        formData.append('transparency', this.wmsSettings.watermark.transparency)
        formData.append('wmFile', this.wmFile)
        const headers = { 'Content-Type': 'multipart/form-data' }
        axios.post('workspace/watermark_image', formData)
      }
    },
    //WFS Settings
    getCurrentWFS() {
      axios.get('workspaces/wfs_settings').then((response) => {
        for (const setting in response.data.wfs) {
          this.$set(this.wfsSettings, setting, response.data.wfs[setting])
        }
      })
    },
    setWFSSettings() {
      axios.put('workspaces/wfs_settings', {
        wfs: this.wfsSettings,
      })
    },
    //GWC Settings
    getLayers() {
      axios.get('gwc/layers').then((response) => {
        this.gwcSettings.layers = response.data
      })
    },
    getGridsets() {
      axios.get('gwc/gridsets').then((response) => {
        this.gwcSettings.gridsets = response.data
      })
    },
    deleteGridset(id) {
      if (this.gwcSettings.config.defaultCachingGridSetIds.string.length > 1) {
        this.gwcSettings.config.defaultCachingGridSetIds.string.splice(id, 1)
      }
    },
    addGridset() {
      if (this.gwcSettings.gridset) {
        this.gwcSettings.config.defaultCachingGridSetIds.string.push(
          this.gwcSettings.gridset
        )
      }
    },
    deleteVFormat(id) {
      if (this.gwcSettings.config.defaultVectorCacheFormats.string.length > 1) {
        this.gwcSettings.config.defaultVectorCacheFormats.string.splice(id, 1)
      }
    },
    addVFormat() {
      if (this.gwcSettings.vformat) {
        this.gwcSettings.config.defaultVectorCacheFormats.string.push(
          this.gwcSettings.vformat
        )
      }
    },
    deleteOFormat(id) {
      if (this.gwcSettings.config.defaultOtherCacheFormats.string.length > 1) {
        this.gwcSettings.config.defaultOtherCacheFormats.string.splice(id, 1)
      }
    },
    addOFormat() {
      if (this.gwcSettings.oformat) {
        this.gwcSettings.config.defaultOtherCacheFormats.string.push(
          this.gwcSettings.oformat
        )
      }
    },
    getCurrentGWC() {
      this.getLayers()
      this.getGridsets()
      axios.get('gwc/config').then((response) => {
        for (const setting in response.data) {
          this.$set(this.gwcSettings.config, setting, response.data[setting])
        }
        if (
          typeof this.gwcSettings.config.defaultCachingGridSetIds.string ==
          'string'
        ) {
          this.$set(
            this.gwcSettings.config.defaultCachingGridSetIds,
            'string',
            [this.gwcSettings.config.defaultCachingGridSetIds.string]
          )
        }
      })
    },
    setGWCSettings() {
      axios.put('gwc/config', {
        GeoServerGWCConfig: this.gwcSettings.config,
      })
    },
    setSettings() {
      this.dialog = false
      this.setWMSSettings()
      this.setWFSSettings()
      this.setGWCSettings()
      this.close()
    },
  },
}
</script>

<style scoped></style>
